/* eslint-disable */
import { CR, RC, AJRS } from './base_i2_success_codes'
import bi1_data_validation from './base_i1_datavalidation'
import base_i3_log from './base_i3_logging'
import Vue from 'vue'

// CI == class instance
// IV == instance variable
class bi11WebSocket {
  
  constructor() {
    const CI = this;

    CI.IV_socket = null;
    CI.IV_loading = false;
    CI.IV_is_connection_established = false;
    CI.IV_socket_end_point = `${window.G_p1s10t1_socket_domain}/p1s10t1-browser-streaming-connection`;
    CI.IV_user_authentication_request_id = null;
    CI.IV_is_user_authenticated = false;
    CI.IV_maximum_connection_retry_count = 10;
    CI.IV_connection_retry_count = 0;
    CI.IV_cicp_layout_information_data = {};
    CI.IV_interface_data_received = false;
    CI.IV_send_queued_events_last_ran = 0;
    CI.IV_send_queued_events_lockout = false;
    CI.IV_last_event_queued_time = 0;
    CI.IV_last_events_sent_time = 0;
    CI.IV_new_event_data_received = false;
    CI.IV_queued_events_to_send = {};
    CI.IV_handle_user_interaction_interval_id = null;
    CI.IV_closing_connection_flag = false;
    CI.IV_apply_event_logic_handler = null;
    CI.IV_org_uid = "";
    CI.IV_cp_uid = "";
    CI.IV_cicp_uid = "";
  }

  bi11SetEventHandlerCallbackFunction(callback_function) {
    const debug_data = [];
    let call_result = {};
    let return_msg = "bi11WebSocket:bi11SetEventHandlerCallbackFunction ";
    const task_id = "bi11WebSocket:bi11SetEventHandlerCallbackFunction";
    const CI = this;

    ///// input validation
    call_result = bi1_data_validation.is_function(callback_function);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    /// </end> input validation

    CI.IV_apply_event_logic_handler = callback_function;
    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  bi11OpenConnection() {
    const CI = this
    CI.IV_socket = new WebSocket(CI.IV_socket_end_point);

    CI.IV_socket.onopen = CI.onOpenCallback.bind(this);
    CI.IV_socket.onclose = CI.onCloseCallback.bind(this);
    CI.IV_socket.onmessage = CI.onDataReceived.bind(this);
    CI.IV_socket.onerror = CI.onErrorCallback.bind(this);
  }

  onOpenCallback(event) {
    const CI = this
    
    console.log("[WS-INFO] Connection established.");
    CI.IV_is_connection_established = true;

    // Resetting the retry count.
    CI.IV_connection_retry_count = 0;

    // Authenticating user first time on connection opening.
    CI.bi11RequestUserAuthentication();
  }

  bi11RequestUserAuthentication() {
    const debug_data = [];
    let call_result = {};
    let return_msg = "bi11WebSocket:bi11RequestUserAuthentication ";
    const task_id = "bi11WebSocket:bi11RequestUserAuthentication";
    const CI = this;

    /// Sending user_info to authenticate user
    CI.IV_user_authentication_request_id = CI.generateRandomUid();
    
    const data = {
      request_id: CI.IV_user_authentication_request_id,
      user_info: {
        user_uid: window.G_web_gui_data.IV_user_info["uid"],
        firebase_email: window.G_web_gui_data.IV_firebase_email_pointer,
        firebase_token: window.G_web_gui_data.IV_id_token_pointer
      },
      is_guest: window.G_firebase_auth.IV_is_guest.toString()
    }

    CI.IV_socket.send(JSON.stringify(data));
    console.log("[WS-INFO] Data sent: 'user_info'");
    ///<END> Sending user_info to authenticate user

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  onErrorCallback(event) {
    const CI = this;
    console.log("[WS-ERROR] Connection could not established.");
    CI.IV_is_connection_established = false;
    
    if (CI.IV_connection_retry_count < CI.IV_maximum_connection_retry_count) {
      CI.IV_connection_retry_count += 1;
      setTimeout(CI.bi11OpenConnection.bind(CI), 500);
    }
  }

  onCloseCallback(event) {
    const CI = this;
    console.log("[WS-INFO] Connection closed.");

    CI.IV_is_connection_established = false;
    CI.IV_is_user_authenticated = false;

    /// If it was not intentional close, we'll try to reconnect
    if (CI.IV_closing_connection_flag === false) {
      CI.IV_connection_retry_count += 1;
      setTimeout(CI.bi11OpenConnection.bind(CI), 500);
    }
    ///</end> If it was not intentional close, we'll try to reconnect
  }

  bi11CloseConnection() {
    const CI = this;
    CI.IV_closing_connection_flag = true;
    CI.IV_socket.close();
  }

  onDataReceived(event) {
    const debug_data = [];
    let call_result = {};
    let return_msg = "bi11WebSocket:onDataReceived ";
    const task_id = "bi11WebSocket:onDataReceived";

    const CI = this;
    const response_data_dict = JSON.parse(event.data);

    for (let response_key in response_data_dict) {

      /// Handeling "request_result" key from response
      if (response_key == "request_result") {
        console.log("[WS-INFO] Data Received [request_result].");
        let data = response_data_dict[response_key];

        /// Checking if user is not authenticated and request 
        if (CI.IV_is_user_authenticated === false && data.request_id === CI.IV_user_authentication_request_id) {
          if (data.success_code === RC.success) {
            CI.IV_is_user_authenticated = true;
            console.log("[WS-INFO] User authenticated successfully.");

            if (CI.IV_org_uid && CI.IV_cp_uid && CI.IV_cicp_uid) {
              CI.bi11RequestCicpInformation(CI.IV_org_uid, CI.IV_cp_uid, CI.IV_cicp_uid);
            }

            CI.startHandleUserInteractionInterval();
          } else {
            debug_data.push(data.debug_data);
            return_msg += 'Unable to authenticate user.';
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.general_failure, return_msg, debug_data);
          }
        ///</end> Checking if user is not authenticated and request 
        } else {
          if (data.success_code !== RC.success) {
            return_msg += 'Request posting data to websocket is failed.';
            base_i3_log(G_username, G_ip, G_page_id, task_id, RC.general_failure, return_msg, debug_data);
          }
        }
      }
      ///</end> Handeling "request_result" key from response

      /// Handeling "event_data" key from response
      if (response_key == "event_data") {
        console.log("[WS-INFO] Data Received [event_data].");
        CI.cicpNewEventsReceivedCallback(response_data_dict[response_key]);
      }
      ///</end> Handeling "event_data" key from response

      /// Handeling "interface_data" key from response
      if (response_key == "interface_data") {
        console.log("[WS-INFO] Data Received [interface_data].");
        CI.deviceInterfaceDataReceivedCallback(response_data_dict[response_key]);
      }
      ///</end> Handeling "interface_data" key from response
    }

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  bi11RequestCicpInformation(org_uid, cp_uid, cicp_uid) {
    const debug_data = [];
    let call_result = {};
    let return_msg = "bi11WebSocket:bi11RequestCicpInformation ";
    const task_id = "bi11WebSocket:bi11RequestCicpInformation";
    const CI = this;

    if (CI.IV_is_user_authenticated === false) {
      setTimeout(function() {
        CI.bi11RequestCicpInformation(org_uid, cp_uid, cicp_uid);
      }, 1000);
      return;
    }

    ////// input validation
    call_result = bi1_data_validation.is_string(org_uid);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(cicp_uid);
    debug_data.push(call_result);

    let validation_failed = false;
    for (let index in debug_data) {
      if (debug_data[index][CR.success] !== RC.success) {
        validation_failed = true;
      }
    }

    if (validation_failed === true) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    //////</end> input validation

    CI.IV_org_uid = org_uid;
    CI.IV_cp_uid = cp_uid;
    CI.IV_cicp_uid = cicp_uid;

    /// Sending cicp_info to authenticate user
    const data = {
      request_id: CI.generateRandomUid(),
      cicp_info: {
        cp_uid: cp_uid,
        cicp_uid: cicp_uid,
        org_uid: parseInt(org_uid)
      }
    }

    CI.IV_socket.send(JSON.stringify(data));
    console.log("[WS-INFO] Data sent: 'cicp_info'");

    ///<END> Sending cicp_info to authenticate user
    return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
  }

  bi11HandleQueuedEventsSendLoop() {
    const debug_data = [];
    let call_result = {};
    let return_msg = "bi11WebSocket:bi11HandleQueuedEventsSendLoop ";
    const task_id = "bi11WebSocket:bi11HandleQueuedEventsSendLoop";
    const CI = this;
    
    // Preventing a second call of bi11HandleQueuedEventsSendLoop to run while a previous one already is running.
    const now = new Date().getTime();
    if (CI.IV_send_queued_events_lockout === true) {

      /// resetting the lockout if last run was before 5 seconds.
      if (now - CI.IV_send_queued_events_last_ran > 5000) {
        CI.IV_send_queued_events_lockout = false;
      }
      /// </END> resetting the lockout if last run was before 5 seconds.
      return;
    }

    // Setting lock to prevent duplicate/parallel running of function. 
    CI.IV_send_queued_events_lockout = true;

    /// Checking: return and release lock if we don't have any new events queued to send them to backend control.
    if (CI.IV_last_event_queued_time <= CI.IV_last_events_sent_time) {
      CI.IV_send_queued_events_lockout = false;
      return;
    }
    /// </END> Checking: return and release lock if we don't have any new events queued to send them to backend control.

    // Setting time for last time send_queued events. 
    CI.IV_send_queued_events_last_ran = new Date().getTime();
    const events_to_send = [];
    const events_to_remove = {};

    let org_uid, cp_uid, cicp_uid;

    /// Extracting out new events from queue
    for (let timestamp in CI.IV_queued_events_to_send) {
      let events = CI.IV_queued_events_to_send[timestamp];

      if (timestamp in events_to_remove === false) {
        events_to_remove[timestamp] = {};
      }
      for (let custom_key in events) {
        const split_keys = custom_key.split("|");
        org_uid = split_keys[2];
        cp_uid = split_keys[3];
        cicp_uid = split_keys[4];

        if (events[custom_key].timestamp > CI.IV_last_events_sent_time) {
          events_to_send.push(events[custom_key]);
          events_to_remove[timestamp][custom_key] = {};
        }
      }
    }
    /// </END> Extracting out new events from queue

    if (events_to_send.length < 1) {
      CI.IV_send_queued_events_lockout = false;
      return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
    }

    CI.IV_last_events_sent_time = new Date().getTime();

    /// Delete events that were successfully uploaded from CI.IV_queued_events_to_send
    const removeSentEvents = function() {
      for (let timestamp in events_to_remove) {
        for (let key in events_to_remove[timestamp]) {
          delete CI.IV_queued_events_to_send[timestamp][key];
        }

        if (Object.keys(CI.IV_queued_events_to_send[timestamp]).length === 0) {
          delete CI.IV_queued_events_to_send[timestamp];
        }
      }
    }
    /// </end> Delete events that were successfully uploaded from CI.IV_queued_events_to_send

    let data = {
      request_id: CI.generateRandomUid(),
      user_interactions: events_to_send
    }

    CI.IV_socket.send(JSON.stringify(data));
    console.log("[WS-INFO] Data sent: 'user_interactions'");
    CI.IV_send_queued_events_lockout = false;
    removeSentEvents()

    return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
  }

  bi11QueueEventSend(button_id, action_type, timestamp, org_uid, cp_uid, cicp_uid) {
    const debug_data = [];
    let return_msg = "bi11WebSocket:bi11QueueEventSend ";
    const task_id = "bi11WebSocket:bi11QueueEventSend";
    const CI = this;

    ////// input validation
    let call_result = bi1_data_validation.is_number(button_id);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(action_type);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_number(timestamp);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(org_uid);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(cp_uid);
    debug_data.push(call_result);
    call_result = bi1_data_validation.is_string(cicp_uid);
    debug_data.push(call_result);

    let validation_failed = false;
    for (let index in debug_data) {
      if (debug_data[index][CR.success] !== RC.success) {
        validation_failed = true;
      }
    }

    if (validation_failed === true) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    //////</end> input validation

    const timestamp_seconds = Math.round(timestamp/1000);
    const timestamp_miliseconds = timestamp % 1000;
    const custom_key = `${timestamp_miliseconds}|${button_id}|${org_uid}|${cp_uid}|${cicp_uid}`;

    /// Queuing new event
    if (timestamp_seconds in CI.IV_queued_events_to_send === false) {
      CI.IV_queued_events_to_send[timestamp_seconds] = {}
    }

    CI.IV_queued_events_to_send[timestamp_seconds][custom_key] = {
      button_id: button_id,
      action_type: action_type,
      timestamp: timestamp
    }
    /// </end> Queuing new event 

    // Setting current time to IV_last_event_queued_time so that bi11HandleQueuedEventsSendLoop will know if there are new events available to send.
    CI.IV_last_event_queued_time = new Date().getTime();

    return { success: RC.success, return_msg: return_msg, debug_data: debug_data };
  }

  cicpNewEventsReceivedCallback(data) {
    const debug_data = [];
    let return_msg = 'bi11WebSocket:cicpNewEventsReceivedCallback ';
    let call_result = {};
    const task_id = 'bi11WebSocket:cicpNewEventsReceivedCallback';
    const CI = this;

    /// input validation 
    if (data === null) {
      return_msg += 'new cicp events data argument is null';
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }

    //// Checking that IV_apply_event_logic_handler is already set.
    call_result = bi1_data_validation.is_function(CI.IV_apply_event_logic_handler);
    debug_data.push(call_result);
    if (call_result[CR.success] !== RC.success) {
      return_msg += "input validation failed";
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { success: RC.input_validation_failed, return_msg: return_msg, debug_data: debug_data };
    }
    ////</end> Checking that IV_apply_event_logic_handler is already set.
    ///</end> input validation 

    for (let event of data) {
      CI.IV_apply_event_logic_handler(event);
    }
    CI.IV_new_event_data_received = true

    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  generateRandomUid() {
    return `${Math.random().toString(36).substring(2).toUpperCase()}-${new Date().getTime()}`;
  }

  deviceInterfaceDataReceivedCallback(data) {
    const debug_data = [];
    let return_msg = 'bi11WebSocket:deviceInterfaceDataReceivedCallback ';
    const task_id = 'bi11WebSocket:deviceInterfaceDataReceivedCallback';

    ////// input validation 
    if (data === null) {
      return_msg += 'device interface data argument is null';
      base_i3_log(G_username, G_ip, G_page_id, task_id, RC.input_validation_failed, return_msg, debug_data);
      return { 'success': RC.input_validation_failed, 'return_msg': return_msg, 'debug_data': debug_data };
    }
    //////</end> input validation 

    const CI = this;
    CI.IV_interface_data_received = true;
    Vue.set(CI.IV_cicp_layout_information_data, 'responsive_layout', data);
 
    return { 'success': RC.success, 'return_msg': return_msg, 'debug_data': debug_data };
  }

  startHandleUserInteractionInterval() {
    const CI = this;
    let interval_id = setInterval(CI.bi11HandleQueuedEventsSendLoop.bind(CI), 1000);
    CI.IV_handle_user_interaction_interval_id = interval_id;
  }

  clearHandleUserInteractionInterval() {
    const CI = this;
    if (CI.IV_handle_user_interaction_interval_id)
      clearInterval(CI.IV_handle_user_interaction_interval_id);
  }

}

export default bi11WebSocket



// WEBPACK FOOTER //
// ./src/watchdog_includes/base_i11_web_socket.js